import PropTypes from "prop-types"
import React from 'react'
import intl from 'react-intl-universal'

import AceiteReadOnlyRenegociacaoPedidoStyled
  from './aceite-read-only-renegociacao-pedido.styled'
import { showDeliveryTime, formatDeliveryTime } from 'utils/delivery-time'
import { formatNumber } from 'utils/format';

const AceiteReadOnlyRenegociacaoPedido = ({
  dataColeta,
  dataEntrega,
  horaEntrega,
  quantidadeAtual,
  justificationDescription,
  idFornecedor,
  IdFornecedorAnterior,
  nomeFornecedor,
  nomeFornecedorAnterior,
}) => (
  <AceiteReadOnlyRenegociacaoPedidoStyled>
    <div className="renegotiation-order-read-offer">
      {dataColeta && (
        <div className="renegotiation-order-read-column">
          <span>{intl.get("stocks.collectionDate")}</span>
          <span>{dataColeta}</span>
        </div>
      )}
      {dataEntrega && (
        <div className="renegotiation-order-read-column">
          <span>{intl.get("stocks.deliveryDate")}</span>
          <span>{dataEntrega}</span>
        </div>
      )}
    </div>
    <div className="renegotiation-order-read-offer">
      {quantidadeAtual && (
        <div
          className="renegotiation-order-read-column"
          style={{ marginLeft: "0" }}
        >
          <span>{intl.get("commons.quantity")}:</span>
          <span>{formatNumber(quantidadeAtual)}</span>
        </div>
      )}
      {showDeliveryTime(horaEntrega) && (
        <div className="renegotiation-order-read-column">
          <span>{intl.get("commons.deliveryTime")}:</span>
          <span>{formatDeliveryTime(horaEntrega)}</span>
        </div>
      )}
    </div>

    {nomeFornecedorAnterior && (
      <div className="renegotiation-order-read-offer">
        <div className="renegotiation-order-read-column">
          <span>{intl.get("stocks.timeline.previousOrigin")}</span>
          <span>{nomeFornecedorAnterior}</span>
        </div>
        <div className="renegotiation-order-read-column">
          <span />
          <span />
        </div>
      </div>
    )}

    {nomeFornecedor && (
      <div className="renegotiation-order-read-offer">
        <div className="renegotiation-order-read-column">
          <span>{intl.get("stocks.timeline.currentOrigin")}</span>
          <span>{nomeFornecedor}</span>
        </div>
        <div className="renegotiation-order-read-column">
          <span />
          <span />
        </div>
      </div>
    )}

    {justificationDescription && (
      <div className="renegotiation-order-read-offer">
        <div
          className="renegotiation-order-read-column"
          style={{ marginLeft: "0" }}
        >
          <span>{intl.get("stocks.timeline.justification")}</span>
          <span>{justificationDescription}</span>
        </div>
      </div>
    )}
  </AceiteReadOnlyRenegociacaoPedidoStyled>
);

AceiteReadOnlyRenegociacaoPedido.propTypes = {
  dataColeta: PropTypes.any.isRequired,
  dataEntrega: PropTypes.any.isRequired,
  horaEntrega: PropTypes.any.isRequired,
  quantidadeAtual: PropTypes.any.isRequired,
  justificationDescription: PropTypes.any.isRequired,
  idFornecedor: PropTypes.any.isRequired,
  IdFornecedorAnterior: PropTypes.any.isRequired,
  nomeFornecedor: PropTypes.any.isRequired,
  nomeFornecedorAnterior: PropTypes.any.isRequired,
};

export default AceiteReadOnlyRenegociacaoPedido
